import axios from "axios";
import { getCleanAccessToken } from "@/utils/auth-token";

const prefix = import.meta.env.VITE_BE_HOST || "http://localhost:8080";

const getConfig = () => {
  return {
    headers: {
      "x-access-token": getCleanAccessToken(),
    },
  };
};

let calendarDataAbortController = new AbortController();
export const apiGetCalendarData = ({ locationId, view, date }) => {
  calendarDataAbortController.abort();
  calendarDataAbortController = new AbortController();

  let config = getConfig();
  config = {
    ...config,
    signal: calendarDataAbortController.signal,
    params: {
      location: locationId,
      date: date,
      view: view,
    },
  };
  return axios.get(prefix + `/calendar/2`, config);
};

export const apiUpdateCalendarFilter = (locationId, filter) => {
  return axios.post(
    prefix + `/calendar/filter`,
    {
      locationId,
      filter,
    },
    getConfig(),
  );
};

export const apiGetAppointments = ({ locationId, view, date }) => {
  calendarDataAbortController.abort();
  calendarDataAbortController = new AbortController();

  let config = getConfig();
  config = {
    ...config,
    signal: calendarDataAbortController.signal,
    params: {
      location: locationId,
      date: date,
      view: view,
    },
  };
  return axios.get(prefix + `/calendar/appointments`, config);
};

export const apiCreateBreak = (breakData) => {
  const config = getConfig();
  // TODO new api route
  return axios.post(prefix + `/calendar/break`, breakData, config);
};

export const apiUpdateCustomerOnPreScheduledAppointment = (
  appointmentId,
  userAppointmentId,
  data,
) => {
  const config = getConfig();
  return axios.patch(
    prefix +
      `/calendar/appointment/prescheduled/${appointmentId}/${userAppointmentId}`,
    data,
    config,
  );
};
